mx.comp.MetadataField = Ext.extend(Ext.form.TextField, {
    editor: null,
    border: false,
    initComponent: function() {
        mx.comp.MetadataField.superclass.initComponent.call(this);
        this.on(
            'render',
            function() {
                //            debugger;
            },
            this
        );
    },
    setMetaData: function(meta) {
        this.editor = new Ext.form.TextField();
        this.ownerCt.layout.renderItem(this.editor);
        //        this.editor.render(this.body);
    },
});
